<template>
  <div>
    <RfPromoDetailsInfoRow title="Settings">
      <template #promodetail>
        <div>
          {{ renderSettings }}
        </div>
        <div class="pd-info-edit">
          <RfButton
            iconSize="16"
            icon="md:edit"
            color="accent"
            size="x-small"
            variant="plain"
            density="compact"
            :disabled="editDisabled"
            @click="showSettingsDetailDialog"
          />
        </div>
      </template>
    </RfPromoDetailsInfoRow>
    <v-dialog
      v-model="showSettingsInfoDialog"
      width="500"
      contentClass="show-promo-details-actions"
      persistent
    >
      <v-card flat>
        <v-card-title class="headline">Settings</v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="bullets"
            label="Slider bullets"
            hideDetails
            style="margin-bottom: 1.2rem"
          ></v-checkbox>
          <v-text-field
            ref="autoplay"
            v-model.trim="autoplay"
            density="compact"
            variant="outlined"
            persistentHint
            persistentPlaceholder
            autofocus
            placeholder="0"
            min="0"
            label="Autoplay"
            type="number"
            hint="Specify a number in seconds. Use 0 to disable"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn
            size="large"
            class="cancel-btn"
            variant="outlined"
            width="100px"
            @click="closeDialog"
            >Close</v-btn
          >
          <v-btn
            size="large"
            width="200px"
            color="primary"
            variant="flat"
            @click="submitConfiguration"
          >
            <v-icon size="small" start>md:save</v-icon>Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RfPromoDetailsInfoRow from "@/components/RfPromotions/RfPromoDetailsInfoRow.vue";
import RfButton from "@/components/buttons/RfButton.vue";
import { cloneDeep } from "lodash-es";
import { useToastsStore } from "@/pinia/toastsStore";
import { usePromptStore } from "@/pinia/promptStore";
import StringUtils from "@/utils/StringUtils";

export default {
  name: "RfSliderSettings",
  components: { RfPromoDetailsInfoRow, RfButton },
  props: ["path", "editDisabled"],
  setup: () => ({ toastsStore: useToastsStore(), promptStore: usePromptStore() }),
  data() {
    return {
      showSettingsInfoDialog: false,
      autoplay: this.path.settings.slider_auto_loop,
      bullets: this.path.settings.slider_bullets,
    };
  },
  computed: {
    renderSettings() {
      let msg = "Autoplay disabled";
      const seconds = StringUtils.pluralize("second", this.autoplay);
      if (parseInt(this.autoplay) > 0) msg = `Autoplay ${this.autoplay} ${seconds}`;

      msg += `, bullets ${this.bullets || false ? "on" : "off"}`;

      return msg;
    },
  },
  watch: {
    path(to) {
      this.autoplay = to.settings.slider_auto_loop;
      this.bullets = to.settings.slider_bullets;
    },
  },
  methods: {
    closeDialog() {
      this.showSettingsInfoDialog = false;
    },
    showSettingsDetailDialog() {
      this.showSettingsInfoDialog = true;
    },
    submitConfiguration() {
      try {
        const model = cloneDeep(this.path);
        model.settings.slider_auto_loop = this.autoplay;
        model.settings.slider_bullets = this.bullets;

        this.promptStore.updatePathGroup({ appId: this.$route.params.aid, model });

        this.showSettingsInfoDialog = false;
        this.toastsStore.create({ type: "success", body: "Prompt updated successfully" });
      } catch (e) {
        this.toastsStore.create({ type: "error", body: e.message });
      }
    },
  },
};
</script>
